import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, matchPath, useLocation } from 'react-router';

import { Tooltip } from '@fly/core';
import { NAV_ITEMS, NavMenuItem } from '@fly/shared';
import { useFeatureToggle } from '@fly/shared-hooks';
import { FlySvgSprite } from '@fly/svg';
import cn from 'classnames';

export const SideBarNav: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { hasFeature } = useFeatureToggle();

  return (
    <aside
      className='relative top-[56px] flex shrink-0 overflow-visible transition-[width] duration-1000'
      data-testid='app-sidebar-nav'
    >
      <ul className='flex w-[56px] list-none flex-col gap-fly-6 p-fly-4 pb-fly-3'>
        {NAV_ITEMS.map((item: NavMenuItem) => {
          if (item.feature && !hasFeature(item.feature)) {
            return null;
          }

          const isActive = !!matchPath(
            { path: item.path!, end: item.path === '/' },
            location.pathname
          );

          return (
            <li
              key={item.title}
              data-testid={t(`${item.title}`, { defaultValue: item.title })}
              className={cn(
                'h-8 text-gray-10 flex items-center justify-center rounded-full border-[0.5px] border-transparent',
                isActive
                  ? 'border-gray-5 bg-gray-4 text-(--text-color) opacity-100'
                  : 'opacity-72'
              )}
            >
              <Tooltip side='right' content={t(`${item.title}`)}>
                <NavLink
                  to={item.path!}
                  end={item.path === '/'}
                  className='font-normal flex h-full w-full items-center justify-center'
                  aria-label={t(`${item.title}`)}
                >
                  <FlySvgSprite
                    className='text-slate-12 fill-transparent'
                    name={item.svgIcon!}
                    size={18}
                  />
                </NavLink>
              </Tooltip>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};
